import React from "react";
import PropTypes from "prop-types";
import { Button, Icon } from "semantic-ui-react";

/**
 * OrganizerStructureItem: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Item component representing a context / structure element
 * that can be selected in the OrganizerStructureBrowser
 *
 * @param {*} props
 */
const OrganizerStructureItem = props => (
  <div className={`or-tree-item${props.isSelected ? " selected" : ""}`}>
    <Button onClick={props.onSelect} color={props.isSelected ? "blue" : null}>
      <Icon name="folder" />
      <span>{props.title}</span>
    </Button>
  </div>
);

OrganizerStructureItem.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  isSelected: PropTypes.bool
};

OrganizerStructureItem.defaultProps = {
  isSelected: false
};

export default OrganizerStructureItem;



// WEBPACK FOOTER //
// ./src/modules/organizer/tree/OrganizerStructureItem.js